import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ThemeButton from "./components/common/ThemeButton";
import PageProgress from "./components/progresses/PageProgress";
import PageProgress2 from "./components/progresses/PageProgress2";
import { Analytics } from "@vercel/analytics/react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeButton />
    <App />

    {/* ============== Page Progress ============== */}
    <PageProgress color="blue" />
    {/* ============== Page Progress ============== */}

    {/* ============== Page Progress 2 ============== */}
    <PageProgress2 color="blue" />
    {/* ============== Page Progress 2 ============== */}

    <Analytics />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
